import React, { Component } from "react";
// styles for page
import "./project_register_main.css";

import { Link } from "react-router-dom";
// images for page
// import icons
import { Icon } from "react-icons-kit";
import Ionicon from "react-ionicons";
//

import { smallDown } from "react-icons-kit/entypo/smallDown";

export default class ProjectRegisterHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewMode: false
    };
    this.getActions = this.getActions.bind(this);
    this.projectBody = null;
  }
  getActions(e) {
    if (e == "preview") {
      this.projectBody.classList.toggle("previewMode");
      this.setState({
        previewMode: !this.state.previewMode
      });
      
    }
  }
  // open element in fullscreen mode
  openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari & Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
  }
  // exit fullscreen mode
  closeFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      /* Firefox */
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE/Edge */
      document.msExitFullscreen();
    }
  }
  componentDidMount() {
    this.projectBody = document.getElementsByClassName("ProjMainRegister")[0];
    let index = Object.keys(this.refs)[0];
    this.refs[index].classList.add("activeStep");
    this.refs[index].classList.add("complete");
    this.refs[index].innerHTML =
      "<div class='activeParent'><div class='circleBigNode'>" +
      `PAGE ${1}` +
      "</div><div class='circleSmallNode'>Your landing homepage</div></div>";
  }

  componentDidUpdate() {
    // fullscren settings
    // if (this.state.previewMode) {
    //   this.openFullscreen(this.projectBody);
    // } else {
    //   this.closeFullscreen();
    // }
    let currentStep = this.props.stepNav[2];
    let activeRef = Object.keys(this.refs)[currentStep - 1];
    let textNode = "";
    for (let i = 0; i < Object.keys(this.refs).length; i++) {
      let key = Object.keys(this.refs)[i];
      this.refs[key].textContent = i + 1;
      if (currentStep == 1) {
        textNode =
          "<div class='activeParent'><div class='circleBigNode'>" +
          `PAGE ${currentStep}` +
          "</div><div class='circleSmallNode'>Your landing homepage</div></div>";
      }
      if (currentStep == 2) {
        textNode =
          "<div class='activeParent'><div class='circleBigNode'>" +
          `PAGE ${currentStep}` +
          "</div><div class='circleSmallNode'>Your landing homepage</div></div>";
      }
      if (currentStep == 3) {
        textNode =
          "<div class='activeParent'><div class='circleBigNode'>" +
          `PAGE ${currentStep}` +
          "</div><div class='circleSmallNode'>Your landing homepage</div></div>";
      }
      if (currentStep == 4) {
        textNode =
          "<div class='activeParent'><div class='circleBigNode'>" +
          `PAGE ${currentStep}` +
          "</div><div class='circleSmallNode'>Your landing homepage</div></div>";
      }
      this.refs[key].classList.remove("activeStep");
    }
    this.refs[activeRef].classList.add("activeStep");
    this.refs[activeRef].classList.add("complete");
    this.refs[activeRef].innerHTML = textNode;
  }
  render() {
    return (
      <React.Fragment>
        <div className="stepRegisterHeader">
          <div className="stepRegisterHeaderLeft">
            <Link to="/dashboard" className="perfectCenter toDashboard">
              <Ionicon icon="ios-apps" fontSize="30px" color="white" />
              <span>Dashboard</span>
            </Link>
            <div className="projectTitle">
              {window.localStorage.hasOwnProperty("subdomain")
                ? window.localStorage.getItem("subdomain")
                : "Project Title"}
            </div>
            <div className="stepNavigation">
              <div
                className="circle "
                ref="first"
                onClick={() => this.props.stepChange(1)}
              >
                1
              </div>
              <div className="centerLine">
                <div className="line" />
              </div>
              <div
                className="circle "
                ref="second"
                onClick={() => this.props.stepChange(2)}
              >
                2
              </div>
              <div className="centerLine">
                <div className="line" />
              </div>
              <div
                className="circle "
                ref="third"
                onClick={() => this.props.stepChange(3)}
              >
                3
              </div>
              <div className="centerLine">
                <div className="line" />
              </div>
              <div
                className="circle"
                ref="fourth"
                onClick={() => this.props.stepChange(4)}
              >
                4
              </div>
            </div>
          </div>
          <div className="stepRegisterHeaderCenter perfectCenter">
            <div className="perfectCenter">
              <Ionicon
                icon="ios-information-circle"
                fontSize="40px"
                color="#484f5a"
              />
            </div>
            <div className="hintText">
              <div className="hintHeader">Hint</div>
              <div>Hint DO NOT mention the price on the 1st page... </div>
            </div>
            <div className="hintNavigation">
              <Ionicon
                icon="ios-arrow-dropleft"
                fontSize="18px"
                color="#101721"
              />
              <Ionicon
                icon="ios-arrow-dropright"
                fontSize="18px"
                color="#ffffff"
              />
            </div>
          </div>
          <div className="stepRegisterHeaderRight">
            <div className="undoRedo">
              <div className="action" id="undo">
                <Ionicon icon="ios-undo" fontSize="30px" color="#ffffff" />
                <span>Undo</span>
              </div>
              <div className="action" id="redo" >
                <Ionicon icon="ios-redo" fontSize="30px" color="#ffffff" />
                <span>Redo</span>
              </div>
            </div>
            <button
              className="gradientButton headerButton "
              onClick={this.props.save}
            >
              SAVE CHANGES
            </button>

            <div
              className="action marginFromRIght"
              onClick={() => this.getActions("preview")}
            >
              <Ionicon icon="ios-eye" fontSize="30px" color="#ffffff" />
              <span>Preview</span>
            </div>
            <div className="action">
              <Ionicon
                icon="ios-help-circle-outline"
                fontSize="30px"
                color="#ffffff"
              />
              <span>Instruction</span>
            </div>
            <div className="productState">
              UNPUBLISHED
              <Ionicon icon="ios-arrow-down" fontSize="10px" color="#ffffff" />
            </div>
          </div>
        </div>
        <div
          className="ellipse perfectCenter"
          onClick={() => this.getActions("preview")}
        >
          {this.state.previewMode ? (
            <Ionicon icon="ios-arrow-down" fontSize="16px" color="#ffffff" />
          ) : (
            <Ionicon icon="ios-arrow-up" fontSize="16px" color="#ffffff" />
          )}
        </div>
      </React.Fragment>
    );
  }
}
